export default "__VITE_ASSET__Chj6jdek__"